import React, {useState, useEffect} from 'react';
import {
  Container, Row, Col, Card, Alert, CardBody, Media, Button,
} from 'reactstrap';
import {connect} from 'react-redux';
import Breadcrumb from '../../components/Common/Breadcrumb';
import avatar from '../../assets/images/users/avatar-1.jpg';
import {editProfile} from '../../store/actions';
import FormField from '../../components/Common/FormField';

const UserProfile = (props) => {
  const [email, setemail] = useState('');
  const [name, setname] = useState('');
  const [idx, setidx] = useState(1);

  useEffect(() => {
    if (localStorage.getItem('authUser')) {
      const obj = JSON.parse(localStorage.getItem('authUser'));
      if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
        setname(obj.displayName);
        setemail(obj.email);
        setidx(obj.uid);
      } else if (
        (process.env.REACT_APP_DEFAULTAUTH === 'fake') ||
        (process.env.REACT_APP_DEFAULTAUTH === 'jwt')
      ) {
        setname(obj.username);
        setemail(obj.email);
        setidx(obj.uid);
      }
    }
  }, [props.success]);

  function handleValidSubmit(event, values) {
    props.editProfile(values);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>

          {/* Render Breadcrumb */}
          <Breadcrumb title="Skote" breadcrumbItem="Profile" />

          <Row>
            <Col lg="12">
              {props.error && props.error ?
                <Alert color="danger">{props.error}</Alert> : null
              }
              {props.success && props.success ?
                <Alert color="success">{props.success}</Alert> : null
              }

              <Card>
                <CardBody>
                  <Media>
                    <div className="mr-3">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <Media body className="align-self-center">
                      <div className="text-muted">
                        <h5>{name}</h5>
                        <p className="mb-1">{email}</p>
                        <p className="mb-0">Id no: #{idx}</p>
                      </div>
                    </Media>
                  </Media>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4">Change UserName</h4>

          <Card>
            <CardBody>
              <form
                className="form-horizontal"
                onSubmit={handleSubmit(handleValidSubmit, handleInvalidSubmit)}
              >
                <div className="form-group">
                  <FormField
                    name="username"
                    label="UserName"
                    value={name}
                    className="form-control"
                    placeholder="Enter UserName"
                    type="text"
                    required
                  />
                  <FormField name="idx" value={idx} type="hidden"/>
                </div>
                <div className="text-center mt-4">
                  <Button type="submit" color="danger">Edit UserName</Button>
                </div>
              </form>

            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const {error, success} = state.Profile;
  return {error, success};
};

export default connect(mapStatetoProps, {editProfile})(UserProfile);

